import * as React from 'react'
import { View } from 'react-native'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { styled } from '@themes/stitches.config'
import { useNav } from '../hooks/useNav'
import { NavBarView } from './NavigationBar'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from './PopoverNav.components'

const IconButton = styled('button', {
  all: 'unset',

  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',

  backgroundColor: '$slate2',
  border: '1px solid $slate4',
  color: '$slate9',

  variants: {
    size: {
      default: {
        height: 32,
        width: 32,
        borderRadius: 16,
        fontSize: 12,
      },
      lg: {
        height: 48,
        width: 48,
        borderRadius: 24,
      },
      xl: {
        height: 64,
        width: 64,
        borderRadius: 32,
        fontSize: 24,
      },
    },
  },

  defaultVariants: {
    size: 'default',
  },

  cursor: 'pointer',
  '&:hover': { backgroundColor: '$slate4' },
  '&:focus': { boxShadow: `0 0 0 2px $slateA8` },
})

const PopoverNav = () => {
  const { open, setOpen } = useNav()

  return (
    <View style={{ zIndex: 1 }}>
      <Dialog
        defaultOpen
        modal
        open={open}
        onOpenChange={(open) => {
          setOpen(open)
        }}
      >
        <DialogTrigger asChild>
          <IconButton
            size="xl"
            css={{
              position: 'fixed',
              bottom: 44,
              right: 20,
            }}
          >
            <FontAwesomeIcon
              icon={findIconDefinition({ prefix: 'fal', iconName: 'bars' })}
            />
          </IconButton>
        </DialogTrigger>
        <DialogContent>
          <VisuallyHidden.Root>
            <DialogTitle>Purposity navigation</DialogTitle>
            <DialogDescription>
              Use this dialog to navigate through the app
            </DialogDescription>
          </VisuallyHidden.Root>

          {/* <NavigationBar unfixed /> */}
          <NavBarView />

          <DialogClose asChild>
            <IconButton
              size={'default'}
              css={{ position: 'absolute', top: 12, right: 12 }}
            >
              <FontAwesomeIcon
                icon={findIconDefinition({
                  prefix: 'fal',
                  iconName: 'xmark-large',
                })}
              />
            </IconButton>
          </DialogClose>
        </DialogContent>
      </Dialog>
    </View>
  )
}

export default PopoverNav
